export default "__VITE_ASSET__DRilC8gC__"